export function handleTeamLogoImageError(teamIconRef) {
    const imageElement = teamIconRef.current;
    if (imageElement) {
        imageElement.style.display = "none";
    }
}
//# sourceMappingURL=handleTeamLogoImageError.js.map